import { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function ItemSkeletons() {
  return Array.from({ length: 6 }, (_, index) => (
    <div className="item-card-shell" key={`item-skeleton-${index}`} aria-hidden="true">
      <div className="item-button skeleton-card item-skeleton-card">
        <span className="skeleton-dot" />
        <span className="skeleton-line short" />
      </div>
    </div>
  ));
}

export function ItemList({
  items,
  activeItemId,
  loading,
  highlightedItemId,
  onSelect,
  onDelete,
}) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className="panel item-list" aria-busy={loading}>
      <div className="panel-body">
        <button
          type="button"
          className="panel-header collapsible-heading"
          aria-expanded={!collapsed}
          onClick={() => setCollapsed((current) => !current)}
        >
          <span>
            <Inventory2OutlinedIcon /> ITEMS
          </span>
          {loading && (
            <span className="loading-inline" role="status" aria-label="Loading items">
              <span className="loading-spinner" />
              Loading
            </span>
          )}
          {collapsed ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
        </button>
        {!collapsed && (
          <div className="item-list-body">
            {loading && <ItemSkeletons />}
            {!loading && items.length === 0 && (
              <div className="empty-state compact-empty">Items</div>
            )}
            {!loading && items.map((item) => {
              const selected = item.id === Number(activeItemId);
              const highlighted = item.id === Number(highlightedItemId);
              return (
                <div
                  key={item.id}
                  className={`item-card-shell ${highlighted ? "highlighted" : ""}`}
                >
                  <button
                    type="button"
                    className={`item-button ${selected ? "selected" : ""}`}
                    onClick={() => onSelect(item.id)}
                  >
                    <span className="item-icon">
                      <Inventory2OutlinedIcon />
                    </span>
                    <span className="item-name">{item.item_name}</span>
                    {selected && (
                      <span className="selected-check">
                        <CheckCircleIcon fontSize="small" />
                      </span>
                    )}
                  </button>
                  <button
                    type="button"
                    className="card-delete-button"
                    aria-label={`Delete ${item.item_name}`}
                    onClick={() => onDelete(item)}
                  >
                    <CloseIcon fontSize="small" />
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </aside>
  );
}
